import { Button } from '@common/components';

export const DonationInfo = () => {
  return (
    <div className="flex flex-col">
      <p className="pb-8 font-700 text-Gray-600 typo-body4">
        고향사랑기부제 고객센터
      </p>
      <ul className="flex flex-col gap-4 pb-8 font-400 text-Gray-600 typo-body4">
        <li>
          전화 : <a href="tel:1833-9363">1833-9363</a>
        </li>
        <li>운영시간 : 월~금요일 오전 10시 ~ 오후 5시</li>
        <li>고객센터 운영시간에 순차적으로 답변드리겠습니다.</li>
      </ul>
      <ul className="flex items-center gap-4">
        <li>
          <Button
            theme="sub-line"
            dimensions="H26"
            asChild
            className="bg-Gray-white"
          >
            <a
              aria-label="제휴 및 지자체 입점 문의 페이지로 이동"
              href="https://forms.gle/gZjgg76YpXcWgw2p9"
              rel="noreferrer"
              target="_blank"
            >
              제휴 및 지자체 입점 문의
            </a>
          </Button>
        </li>
      </ul>
    </div>
  );
};
